import { Component, Input, OnInit } from '@angular/core';
import { Color, ColorShades, Utils } from 'marketpro-design-lib';
import { SpendingDistribution } from '../../models/spending-distribution.model';
import { constants } from 'projects/marketpro-ui/src/app/constants';
import {
  DataFilters,
  DataFiltersService,
} from '../../services/data-filters.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { flatCategories } from 'projects/marketpro-ui/src/app/utils';
import { CategoryService } from '../../services/categories.service';
import { ToggleableNameValuePair } from '../../models/name-value-pair.model';

@Component({
  selector: 'mpro-spending-distrib-breakdown-table',
  templateUrl: './spending-distrib-breakdown-table.component.html',
  styleUrls: ['./spending-distrib-breakdown-table.component.scss'],
})
export class SpendingDistribBreakdownTableComponent implements OnInit {
  @Input() public sdData: SpendingDistribution[];
  @Input() public total: SpendingDistribution;
  @Input() public selected: string;
  @Input() public inTrillion: boolean = false;
  categoryText: string = 'All Categories';
  private ngUnsubscribe: Subject<void> = new Subject();
  dataFilters: DataFilters;
  private categories: ToggleableNameValuePair[] = [];
  constructor(
    private dataFiltersService: DataFiltersService,
    private categoryService: CategoryService
  ) {}

  public ngOnInit(): void {
    this.dataFiltersService
      .getDataFilters()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((filters) => {
        this.dataFilters = filters;
        this.updateCategoryTag(filters.category);
      });
  }

  updateCategoryTag(category) {
    this.categoryText =
      flatCategories(this.categories).find((o) => o.value === category)?.name ||
      '';
  }

  public getColor(color?: Color) {
    if (color) {
      return Utils.getColorHex(color);
    }

    return '';
  }

  public getBgColor(color?: Color) {
    if (color) {
      return Utils.getColorHex({
        name: color.name,
        shade: ColorShades.Shade200,
      });
    }

    return '';
  }
  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
